import { Delta } from "quill/core";

export type QuillClipboardMatcher = [
  string,
  (node: Node, delta: Delta) => Delta,
];

export const quillClipboardMatchers = {
  img: [
    "img",
    (node, delta) => {
      if (!(node instanceof HTMLImageElement)) return delta;
      const firstOp = delta.ops[0];
      if (!firstOp) return delta;
      if (node.style.width) {
        firstOp.attributes = firstOp.attributes || {};
        firstOp.attributes.width = node.style.width;
      }
      if (node.style.height) {
        firstOp.attributes = firstOp.attributes || {};
        firstOp.attributes.height = node.style.height;
      }
      return delta;
    },
  ],
  disallowBackground: [
    "*",
    (_, delta) => {
      for (const op of delta.ops) {
        // Disallow background color. That's handled at the email block level.
        delete op.attributes?.background;
      }
      return delta;
    },
  ],
} as const satisfies Record<string, QuillClipboardMatcher>;
